namespace TabAurous.Reports {
    export namespace ItemsRegisterService {
        export const baseUrl = 'Reports/ItemsRegister';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ItemsRegisterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchers(request: ReportFiltersRequest, onSuccess?: (response: ItemsRegisterResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/ItemsRegister/List",
            GetVouchers = "Reports/ItemsRegister/GetVouchers"
        }

        [
            'List', 
            'GetVouchers'
        ].forEach(x => {
            (<any>ItemsRegisterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
